// src/types/status.ts

/** Canonical Org user statuses */
export enum OrgUserStatus {
  Active = "Active",
  Inactive = "Inactive",
  New = "New",
  Unregistered = "Unregistered",
}

/** Runtime list of valid statuses (useful for selects, etc.) */
export const ORG_USER_STATUSES: OrgUserStatus[] = [
  OrgUserStatus.Active,
  OrgUserStatus.Inactive,
  OrgUserStatus.New,
  OrgUserStatus.Unregistered,
];

/** Normalizer */
const statusStrategy: Record<string, OrgUserStatus> = {
  active: OrgUserStatus.Active,
  inactive: OrgUserStatus.Inactive,
  new: OrgUserStatus.New,
  unregistered: OrgUserStatus.Unregistered,
};

export function normalizeOrgUsersStatus(
  input: unknown,
  fallback: OrgUserStatus = OrgUserStatus.Inactive
): OrgUserStatus {
  const key = typeof input === "string" ? input.toLowerCase() : "";
  return statusStrategy[key] ?? fallback;
}
